"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/bid/reliablePartnerSettings");
const status_1 = require("../../status");
exports.initialState = {
    isModalOpen: false,
    identifierFetchStatus: status_1.RequestStatusFactory.fetch.standby(),
    disconnectStatus: status_1.RequestStatusFactory.fetch.standby(),
    errorType: '',
    identifierDetails: {
        identifier: null,
        customerUuid: ''
    }
};
exports.methods = {};
const isModalOpenLens = monocle.Lens.fromProp('isModalOpen');
const apiKeyStatusLens = monocle.Lens.fromProp('identifierFetchStatus');
const disconnectStatusLens = monocle.Lens.fromProp('disconnectStatus');
const identifierDetailsDetailsLens = monocle.Lens.fromProp('identifierDetails');
const errorTypeLens = monocle.Lens.fromProp('errorType');
exports.methods[ActionTypes.SET_API_IDENTIFIER_REQUEST] = (state, action) => fp.function.flow(apiKeyStatusLens.set(status_1.RequestStatusFactory.fetch.busy()), identifierDetailsDetailsLens.set(action.payload))(state);
exports.methods[ActionTypes.SET_API_IDENTIFIER_REQUEST_SUCCESS] = (state) => fp.function.flow(apiKeyStatusLens.set(status_1.RequestStatusFactory.fetch.success()))(state);
exports.methods[ActionTypes.SET_API_IDENTIFIER_REQUEST_FAILURE] = (state, action) => {
    var _a;
    return fp.function.flow(apiKeyStatusLens.set(status_1.RequestStatusFactory.fetch.failure()), errorTypeLens.set(((_a = action.payload) === null || _a === void 0 ? void 0 : _a.type) || ''))(state);
};
exports.methods[ActionTypes.UNSET_API_IDENTIFIER_REQUEST] = (state, action) => fp.function.flow(disconnectStatusLens.set(status_1.RequestStatusFactory.fetch.busy()), identifierDetailsDetailsLens.set({
    identifier: null,
    customerUuid: action.payload.customerUuid
}))(state);
exports.methods[ActionTypes.UNSET_API_IDENTIFIER_REQUEST_SUCCESS] = (state) => disconnectStatusLens.set(status_1.RequestStatusFactory.fetch.success())(state);
exports.methods[ActionTypes.UNSET_API_IDENTIFIER_REQUEST_FAILURE] = (state) => disconnectStatusLens.set(status_1.RequestStatusFactory.fetch.failure())(state);
exports.methods[ActionTypes.TOGGLE_MODAL] = (state) => isModalOpenLens.modify((status) => !status)(state);
exports.methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.CLEAR_STATUS] = (state) => fp.function.flow(apiKeyStatusLens.set(status_1.RequestStatusFactory.fetch.standby()), errorTypeLens.set(''))(state);
//# sourceMappingURL=reliablePartnerSettings.js.map